import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from 'components/Page';
import store from 'store';

import NewsSection from './NewsSection';

function News() {
	const { t } = useTranslation();

	// const news = store.sortedNews;

	return (
		<Page title={t('news.main')} type="list" isLoading={store.isNewsLoading}>
			<NewsSection news={store.news} />
		</Page>
	);
}

export default observer(News);
